/** Formats a datetime-local control as a UTC wall-clock value. */
export function isoInput(date: Date): string {
  return date.toISOString().slice(0, 19);
}

/** Parses a datetime-local control as UTC, independent of the browser timezone. */
export function utcInputToIso(value: string): string {
  const withSeconds = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value) ? `${value}:00` : value;
  const date = new Date(`${withSeconds}Z`);
  if (Number.isNaN(date.valueOf())) throw new Error('Invalid UTC datetime');
  return date.toISOString();
}
